export default {
    bullet: '\u2022', // •
    emdash: '\u2014', // —
    endash: '\u2013', // -
    triangleUp: '\u25b2', // ▲
    triangleDown: '\u25bc', // ▼
};
